import { Flex } from 'antd';
import IconNote from 'Assets/icons/icon-note.svg';

import { ITemplate } from './types';

interface SearchTemplateResultProps {
  item: ITemplate;
}

const SearchTemplateResult = ({ item }: SearchTemplateResultProps) => {
  const { templateName } = item;

  return (
    <Flex gap={16} align="center">
      <img src={IconNote} alt="Template" />
      <div style={{ whiteSpace: 'pre-wrap' }}>{templateName}</div>
    </Flex>
  );
};

export default SearchTemplateResult;
